<p *ngIf="isMobile" class="headline6Light"> 2/4 {{ 'registration.stepTwo.titleMobile' | translate}}</p>
<div class="flexCenter">
    <ng-template matStepLabel>DATOS PERSONALES</ng-template>
    <br />
    <div class="card2">
        <p class="headline5NoCenter">{{'registration.stepTwo.title'|translate}}</p>
    </div>
    <br />
</div>
<br />

<form [formGroup]="modeForm">
    <div class="responsiveFlex">
        <ng-template matStepLabel>DATOS PERSONALES</ng-template>
        <mat-card (click)="enablePresencial()" [class]="cardClass1" color="primary">
            <mat-card-title class="headline6">
                <mat-icon>place</mat-icon>{{'registration.stepTwo.cardOne.title'|translate}}
            </mat-card-title>
            <p class="body2">{{'registration.stepTwo.cardOne.text'|translate}}
            </p>

            <mat-form-field class="inputFullWidth2" appearance="fill">
                <mat-label class="body2">{{'registration.stepTwo.cardOne.chooseDay'|translate}}</mat-label>
                <mat-select #matRef>
                    <mat-option class="body2" *ngFor="let option of trainingDays" [value]="option.grupoDescripcion"
                        (click)="saveTrainingDay(option)">
                        {{option.grupoDescripcion}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            
        </mat-card>
        <br />

        <mat-card (click)="disablePresencial()" [class]="cardClass2">
            <mat-card-title class="headline6">
                <mat-icon>public</mat-icon>{{'registration.stepTwo.cardTwo.title'|translate}}
            </mat-card-title>
            <p class="body2">{{'registration.stepTwo.cardTwo.text'|translate}}</p>
        </mat-card>
    </div>
    <br />
    <div class="flexCenter">
        <ng-template matStepLabel>DATOS PERSONALES</ng-template>
        <br />
        <div *ngIf="selected" class="card2">
            <div *ngIf="presencial">
                <p *ngIf="!isMobile" class="headline6">{{'registration.stepTwo.days'|translate}}</p>
                <p *ngIf="isMobile" class="subtitle1">{{'registration.stepTwo.days'|translate}}</p>
            </div>
            <div *ngIf="!presencial">
                <p *ngIf="!isMobile" class="headline6">{{'registration.stepTwo.days2'|translate}}</p>
                <p *ngIf="isMobile" class="subtitle1">{{'registration.stepTwo.days2'|translate}}</p>
            </div>
            <br/>

            <div class="flexInLineCenter">

                <div *ngFor="let day of days">
                    <button *ngIf="!day.selected" [disabled]="day.disabled" (click)="saveDay(day)"
                    mat-stroked-button>{{day.name}}</button>
                    <button *ngIf="day.selected && !day.disabled" class="selectedOption" (click)="saveDay(day)"
                    mat-raised-button>{{day.name}}</button>
                </div>
            </div>
        </div>
        <br />
    </div>
</form>

<div *ngIf="!isMobile" class="cardCenter3">
    <div class="buttonInsideCard">
        <app-buttons [enablePrevious]="true" [mode]="modeForm.value" [disabled]="!valid"></app-buttons>
    </div>
</div>

<app-buttons *ngIf="isMobile" [enablePrevious]="true" [mode]="modeForm.value" [disabled]="!valid"></app-buttons>